module.exports = __webpack_public_path__ + "img/teutoniques_2_cover.51956178.jpg";